<template>
    <div id="storybook-page">
      <div :class="`navigation-panel ${isOpenedNav ? 'is-opened' : ''}`">
        <div class="navigation-menu-wrapper">
        <div class="navigation-menu">
          <CncBadgeLabel class="version-badge" :label="$t('design_system_version')" size="medium" type="neutral"  styleBadge="minimal"></CncBadgeLabel>
          <ul class="group-item" v-for="group in this.nav[ currentMainMenu ].group">
            <div class="txt-group">{{ group.title }}</div>
            <li class="block-item" v-for="block in group.block">
              <div class="txt-block">{{ block.title }}</div>
              <ul class="menu-list">
                <li v-for="menu in block.menu">
                  <a :class="`txt-menu ${currentPath === menu.path ? 'active' : ''}`" :target="menu.path.startsWith('https://') || menu.path.startsWith('http://') ? '_blank' : '_self'" @click="navigateTo(menu.path)">{{ menu.title }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        </div>
        <SettingsPanel/>
      </div>
      <div class="body">
        <slot/>
      </div>
    </div>
</template>

<script>
import Header from './Header.vue'
export default {
  components: {
    SettingsPanel: () => import('./SettingsPanel.vue'),
    Header: () => import('./Header.vue')
  },
  layout: 'plain',
  data () {
    return {
      nav: {
        home: {
          group: [
            { key: 'getting-started',
              title: 'Getting started',
              block: [
                { key: 'basics', title: 'Basics', menu: [] },
                { key: 'ui-library', title: 'UI library', menu: [] },
                { key: 'useful-links',
                  title: 'Useful links',
                  menu: [
                    { key: 'design-system-files-on-figma', title: 'Design system files on Figma →', path: 'https://www.figma.com/files/844138934524630280/team/1085068115519117650' },
                    { key: 'brand-asstes-on-google-drive', title: 'Brand assets on Google Drive →', path: 'https://drive.google.com/drive/folders/1greLE46_R-D11AcV8V4bWH-pCWnTIYHa?usp=drive_link' },
                    { key: 'knowledges-wealth-by-uxui', title: 'Knowledges wealth by UXUI →', path: 'https://drive.google.com/drive/u/0/folders/0ALxs2xnD7Fy3Uk9PVA' }
                  ] }
              ] }
          ] },
        brand: {
          group: [
            { key: 'conicle-corporate',
              title: 'Conicle corporate',
              block: [
                { key: 'who-we-are', title: 'Who we are', menu: [] },
                { key: 'verbal-expression', title: 'Verbal expression', menu: [] },
                { key: 'visual-communication', title: 'Visual communication', menu: [] },
                { key: 'support', title: 'Support', menu: [] }
              ] },
            { key: 'conicle-space',
              title: 'Conicle Space',
              block: [
                { key: 'verbal-expression', title: 'Verbal expression', menu: [] },
                { key: 'visual-communication', title: 'Visual communication', menu: [] },
                { key: 'support', title: 'Support', menu: [] }
              ] },
            { key: 'coniverse',
              title: 'Coniverse',
              block: [
                { key: 'verbal-expression', title: 'Verbal expression', menu: [] },
                { key: 'visual-communication', title: 'Visual communication', menu: [] },
                { key: 'support', title: 'Support', menu: [] }
              ] },
            { key: 'solutions',
              title: 'Solutions',
              block: [
                { key: 'verbal-expression', title: 'Verbal expression', menu: [] },
                { key: 'visual-communication', title: 'Visual communication', menu: [] },
                { key: 'support', title: 'Support', menu: [] }
              ] },
            { key: 'we-are-conicle',
              title: 'We are Conicle',
              block: [
                { key: 'verbal-expression', title: 'Verbal expression', menu: [] },
                { key: 'visual-communication', title: 'Visual communication', menu: [] },
                { key: 'support', title: 'Support', menu: [] }
              ] }
          ] },
        foundations: {
          group: [
            { key: 'conicle-space-and-coniverse',
              title: 'Conicle Space and Coniverse',
              block: [
                { key: 'design-elements', title: 'Design elements', menu: [] },
                { key: 'content', title: 'Contents', menu: [] }
              ] }
          ] },
        components: {
          group: [
            { key: 'conicle-space-and-coniverse',
              title: 'Conicle Space and Coniverse',
              block: [
                { key: 'components', title: 'Components', menu: [] }
              ] }
          ] },
        resources: {
          group: [
            { key: 'logos',
              title: 'Logos',
              block: [
                { key: 'categories', title: 'Categories', menu: [] }
              ] },
            { key: 'icons',
              title: 'Icons',
              block: [
                { key: 'products-and-features', title: 'Products and features', menu: [] },
                { key: 'others', title: 'Others', menu: [] }
              ] },
            { key: 'other-resources',
              title: 'Other resources',
              block: [
                { key: 'design-assets', title: 'Design assets', menu: [] },
                { key: 'templates', title: 'Templates', menu: [] },
                { key: 'documents', title: 'Documents', menu: [] }
              ] }
          ] },
        knowledges: {
          group: [
            { key: 'conicle-space',
              title: 'Conicle Space',
              block: [
                { key: 'standard', title: 'Standard', menu: [] },
                { key: 'lxp', title: 'LXP', menu: [] },
                { key: 'lms', title: 'LMS', menu: [] }
              ] },
            { key: 'design',
              title: 'Design',
              block: [
                { key: 'design-101', title: 'Design 101', menu: [] },
                { key: 'design-references', title: 'Design references', menu: [] }
              ] },
            { key: 'business',
              title: 'Business',
              block: [
                { key: 'hrd-101', title: 'HRD 101', menu: [] }
              ] }
          ] }
      }
    }
  },
  methods: {
    fileNameTotitle (text) {
      return text.split('-')
        .map((word, index) => index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          : word.toLowerCase()
        )
        .join(' ')
    },
    fileNameToKey (text) {
      return text.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('')
    },
    fileNameToUrl (text) {
      return text
    },
    populateMenu (mainMenu, group, block, imported, filesNotUsed, customTitle) {
      const menu = this.nav[mainMenu].group.find((element) => element.key == group).block.find((element) => element.key == block).menu
      imported.keys().forEach(filePath => {
        const fileName = filePath.split('/').pop().replace(/\.[^/.]+$/, '')
        const key = this.fileNameToKey(fileName)
        const title = customTitle[fileName]?.title || this.fileNameTotitle(fileName)
        const path = `/${this.currentMainMenu}/${group}/${block}/${this.fileNameToUrl(fileName)}`
        if (!filesNotUsed.includes(filePath.split('/').pop())) menu.push({ key: key, title: title, path: path })
      })
    },
    initNav () {
      let imported
      imported = require.context('../pages/home/getting-started/basics', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('home', 'getting-started', 'basics', imported, [], {})
      imported = require.context('../pages/home/getting-started/ui-library', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('home', 'getting-started', 'ui-library', imported, [], {})
      imported = require.context('../pages/foundations/conicle-space-and-coniverse/design-elements', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('foundations', 'conicle-space-and-coniverse', 'design-elements', imported, [], {})
      imported = require.context('../pages/foundations/conicle-space-and-coniverse/content', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('foundations', 'conicle-space-and-coniverse', 'content', imported, [], {})
      imported = require.context('../pages/components/conicle-space-and-coniverse/components', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('components', 'conicle-space-and-coniverse', 'components', imported, ['switch.vue'], {})
      imported = require.context('../pages/brand/conicle-corporate/who-we-are', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-corporate', 'who-we-are', imported, [], { 'brand-dna': { title: 'Brand DNA' }, 'vision-mission-and-purpose': { title: 'Vision, mission, and purpose' } })
      imported = require.context('../pages/brand/conicle-corporate/verbal-expression', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-corporate', 'verbal-expression', imported, [], {})
      imported = require.context('../pages/brand/conicle-corporate/visual-communication', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-corporate', 'visual-communication', imported, [], {})
      imported = require.context('../pages/brand/conicle-corporate/support', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-corporate', 'support', imported, [], {})
      imported = require.context('../pages/brand/coniverse/verbal-expression', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'coniverse', 'verbal-expression', imported, [], {})
      imported = require.context('../pages/brand/coniverse/visual-communication', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'coniverse', 'visual-communication', imported, [], {})
      imported = require.context('../pages/brand/coniverse/support', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'coniverse', 'support', imported, [], {})
      imported = require.context('../pages/brand/solutions/verbal-expression', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'solutions', 'verbal-expression', imported, [], {})
      imported = require.context('../pages/brand/solutions/visual-communication', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'solutions', 'visual-communication', imported, [], {})
      imported = require.context('../pages/brand/solutions/support', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'solutions', 'support', imported, [], {})
      imported = require.context('../pages/brand/conicle-space/verbal-expression', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-space', 'verbal-expression', imported, [], {})
      imported = require.context('../pages/brand/conicle-space/visual-communication', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-space', 'visual-communication', imported, [], {})
      imported = require.context('../pages/brand/conicle-space/support', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'conicle-space', 'support', imported, [], {})
      imported = require.context('../pages/brand/we-are-conicle/verbal-expression', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'we-are-conicle', 'verbal-expression', imported, [], {})
      imported = require.context('../pages/brand/we-are-conicle/visual-communication', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'we-are-conicle', 'visual-communication', imported, [], {})
      imported = require.context('../pages/brand/we-are-conicle/support', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('brand', 'we-are-conicle', 'support', imported, [], {})
      imported = require.context('../pages/resources/logos/categories', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('resources', 'logos', 'categories', imported, [], { 'conicle-space': { title: 'Conicle Space' }, 'we-are-conicle': { title: 'We are Conicle' }, 'partners-content-providers': { title: 'Partners (content providers)' } })
      imported = require.context('../pages/resources/icons/products-and-features', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('resources', 'icons', 'products-and-features', imported, [], { 'conicle-space': { title: 'Conicle Space' } })
      imported = require.context('../pages/resources/icons/others', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('resources', 'icons', 'others', imported, [], {})
      imported = require.context('../pages/resources/other-resources/design-assets', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('resources', 'other-resources', 'design-assets', imported, [], {})
      imported = require.context('../pages/resources/other-resources/templates', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('resources', 'other-resources', 'templates', imported, [], {})
      imported = require.context('../pages/resources/other-resources/documents', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('resources', 'other-resources', 'documents', imported, [], {})
      imported = require.context('../pages/knowledges/conicle-space/standard', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('knowledges', 'conicle-space', 'standard', imported, [], { 'lxp': { title: 'LXP' } })
      imported = require.context('../pages/knowledges/conicle-space/lxp', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('knowledges', 'conicle-space', 'lxp', imported, [], { 'lxp-101': { title: 'LXP 101' } })
      imported = require.context('../pages/knowledges/conicle-space/lms', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('knowledges', 'conicle-space', 'lms', imported, [], {})
      imported = require.context('../pages/knowledges/design/design-101', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('knowledges', 'design', 'design-101', imported, [], { 'uxui-glossary': { title: 'UXUI glossary' } })
      imported = require.context('../pages/knowledges/design/design-references', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('knowledges', 'design', 'design-references', imported, [], { 'gamification-ui': { title: 'Gamification Components' } })
      imported = require.context('../pages/knowledges/business/hrd-101', false, /[a-z][a-z\d]*(-[a-z\d]+)*\.(vue|js)$/)
      this.populateMenu('knowledges', 'business', 'hrd-101', imported, [], { 'hrd-glossary': { title: 'HRD glossary' } })
    },
    navigateTo (path) {
      this.$router.push(path)
    }
  },
  mounted () {
    this.$nextTick(this.initNav)
  },
  computed: {
    currentMainMenu () {
      const mainMenu = this.$route.path.split('/').filter(Boolean)[0]
      // return mainMenu == undefined  ? '' : mainMenu ;
      return mainMenu == '' || mainMenu == undefined ? 'home' : mainMenu
    },
    currentPath () {
      return this.$route.path
    }
  },
  props: ['isOpenedNav']
}
</script>

<style lang="scss">

#storybook-page {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  flex-grow: 1;
  --nav-width: 264px;
  --nav-padding: 20px;
  position: relative;

  .navigation-panel {
    flex: 0 0 var(--nav-width);
    width: var(--nav-width);
    display: flex;
    flex-direction: column;
    background: $color-white;
    border-right: solid 1px $color-cool-grey-100;
    z-index: 9999;
    position: relative;
    padding-bottom: 56px;

    @media screen and (max-width: 815px) {
      position: absolute;
      left: calc( -1 * var(--nav-width));
      height: 100%;
      transition: left;
      transition-timing-function: cubic-bezier(0.400, 0.000, 0.700, 0.400);
      transition-duration: 250ms;

      &.is-opened {
        left: 0;
        transition-timing-function: cubic-bezier(0.300, 0.600, 0.500, 1.000);
      }

    }

    .navigation-menu-wrapper {
      flex: 1 1 0;
      overflow: hidden;
      position: relative;

      .navigation-menu {
        padding: var(--nav-padding);
        display: flex;
        flex-direction: column;
        gap: 20px;
        height:100%;
        overflow-y: auto;
        overflow-x: hidden;

        .version-badge {
          display: none;

          @media screen and (max-width: 815px) {
            display: block;
          }
        }

        ul {
            padding: 0;
            margin: 0;
            list-style-type: none;

          .txt-group {
            font: $font-style-title-md-med;
            color: $color-cool-grey-900;
            width: 100%;
          }

          .txt-block {
            font: $font-style-functional-md-reg;
            color: $color-primary-500;
            padding: 6px 0;
            width: 100%;
          }

          .txt-menu {
            font: $font-style-functional-md-reg;
            color: $color-cool-grey-700;
            padding: 6px 8px;
            border-radius: 12px;
            display: block;

            &:hover {
              color: $color-cool-grey-900;
              background-color: $color-cool-grey-50;
            }

            &.active {
              font: $font-style-functional-md-med;
              color: $color-primary-500;
              background-color: $color-primary-50;
            }
          }
        }

        .group-item {
          display: flex;
          flex-direction: column;
          gap: 12px;
          padding-bottom: 16px;
          border-bottom: 1px solid $color-cool-grey-100;
          min-width: calc(var(--nav-width) - (var(--nav-padding) * 2) - 1px);

          &:last-child {
            border: none;
            padding-bottom: 0;
          }
        }
      }
    }
  }

  .body {
    flex-grow: 1;
    overflow-y: auto;
    position: relative;
    height: 100%;
  }
}
</style>
